import { useContext, useEffect, useMemo } from "react";
import getConfig from "../configs/tableConfig";
import BeelditTableHeaderActions from "@beeldit/core/components/BeelditTableHeaderActions";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { t } from "i18next";
import useRemoveAction from "../actions/remove/useRemoveAction";
import useCreateAction from "../actions/create/useCreateAction";
import useListAction from "../actions/list/useListAction";
import { Card } from "react-bootstrap";
import { Article, Browsers } from "@phosphor-icons/react";

function PagesPage(props: any) {
  const { filters, formDefaultValues, config } = props;

  const { user } = useContext(AuthContext);

  const {
    indexFunction,
    detailsFunction,
    actionTemplate: listActionTemplate,
    setTableConfig,
  } = useListAction(user, filters);

  const { initializeFunction, actionTemplate: createActionTemplate } =
    useCreateAction(indexFunction, formDefaultValues);

  const { prepareRemoveFunction, actionTemplate: removeActionTemplate } =
    useRemoveAction(indexFunction);

  /**<newActionsHooks**/

  /**
   * Table configuration definition
   */

  const memoTableConfig = useMemo(
    () =>
      getConfig({
        initializeFunction, // We pass the function to initialize a new element (used in the create button)
        indexFunction, // We pass the function to index the table
        detailsFunction, // We pass the function to get an element (used in the edit button)
        prepareRemoveFunction,
        config,
        /**newActionsTableConfig**/
      }),
    [
      initializeFunction,
      indexFunction,
      detailsFunction,
      prepareRemoveFunction,
      config,
    ]
  );
  useEffect(() => {
    setTableConfig(memoTableConfig);
  }, [memoTableConfig, setTableConfig]);

  return (
    <Card>
      <Card.Header>
        <Card.Title>
          {config.title === "pages" ? (
            <Browsers size={24} />
          ) : config.title === "blog" ? (
            <Article size={24} />
          ) : null}
          {t(config.title ? config.title : "pages")}
        </Card.Title>
        <BeelditTableHeaderActions actions={memoTableConfig.actions} />
      </Card.Header>

      <Card.Body>
        {listActionTemplate}
        {createActionTemplate}
        {removeActionTemplate}
        {/* newTemplateActions */}
      </Card.Body>
    </Card>
  );
}

export default PagesPage;
